import React from 'react';

import { Route, Routes } from 'react-router-dom';

import Layout from 'components/layout';
import CanadianTireCompleteLinking from 'pages/partner-linking/canadian-tire/complete-linking';
import CanadianTireInitiateLinking from 'pages/partner-linking/canadian-tire/initiate-linking';
import PartnerLinkingErrorPage from 'pages/partner-linking/error';
import { routes } from 'utils/routing';

/**
 * Top-level route switch. Microsites (currently the CT partner-linking
 * flow) render outside the main app shell so they don't mount AppHeader,
 * EmergencyBanner, Footer, or the bundle of Sanity feature queries that
 * `Layout` fans out on mount — cuts request count from ~127 to ~42 on
 * an authenticated landing. Everything else falls through to `Layout`.
 *
 * Add new microsite routes here as siblings; the catch-all stays last.
 *
 * The CT partner-linking routes are always registered. Gating on
 * `th-loyalty-ct-partnership-linking-enabled` now happens inside the initiate
 * page, *after* the user is identified, so the flag can target individual
 * users/segments: targeted users proceed, everyone else is redirected to the
 * partner-linking error screen. (Previously the flag gated route registration
 * here, but that ran against the anonymous LD context so no user could be
 * targeted, and disabled users fell through to the generic app 404.)
 */
export default function TopLevelRoutes(): JSX.Element {
  return (
    <Routes>
      <Route
        path={routes.partnerLinkingCanadianTireInitiate}
        element={<CanadianTireInitiateLinking />}
      />
      <Route
        path={routes.partnerLinkingCanadianTireCallback}
        element={<CanadianTireCompleteLinking />}
      />
      <Route path={routes.partnerLinkingError} element={<PartnerLinkingErrorPage />} />
      <Route path="*" element={<Layout />} />
    </Routes>
  );
}
